module.exports = __webpack_public_path__ + "static/media/spain.6a9dc11f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flag/spain.svg
// module id = 427
// module chunks = 120